<template>
    <section id="contact" class="grid-section">
        <div class="content">
            <transition name="slide-left">
                <h2 class="section-head" v-if="showImpressum === true">Impressum</h2>
            </transition>
        </div>
        <div class="impressum" id="imp-col-1">
            <transition name="slide-left">
                <div class="transition-wrapper" v-if="showImpressum === true">
                    <h3>Angaben gemäß § 5 TMG</h3>
                    <p>Tobias Hoffmann<br>Sewanstraße 168<br>10319 Berlin</p>
                    <br>
                    <h3>Kontakt</h3>
                    <p>Telefon: +49 (0) 176 43 83 63 44<br>E-Mail: hi@tobihoffmann.com</p>
                </div>
            </transition>
        </div>
        <div class="impressum" id="imp-col-2">
            <transition name="slide-left">
                <div class="transition-wrapper" v-if="showImpressum === true">
                    <h3>Urheberrecht</h3>
                    <p>Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem
                        deutschen
                        Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung
                        außerhalb
                        der
                        Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw.
                        Erstellers.
                        Downloads und Kopien dieser Seite sind nur für den privaten, nicht kommerziellen Gebrauch
                        gestattet.</p>
                    <p>Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden, werden die Urheberrechte
                        Dritter
                        beachtet. Insbesondere werden Inhalte Dritter als solche gekennzeichnet. Sollten Sie trotzdem
                        auf
                        eine
                        Urheberrechtsverletzung aufmerksam werden, bitten wir um einen entsprechenden Hinweis. Bei
                        Bekanntwerden
                        von Rechtsverletzungen werden wir derartige Inhalte umgehend entfernen.</p>
                </div>
            </transition>
        </div>
        <div class="impressum" id="imp-col-3">
            <transition name="slide-left">
                <div class="transition-wrapper" v-if="showImpressum === true">
                    <h3>Haftung für Links</h3>
                    <p>Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss
                        haben.
                        Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der
                        verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich. Die
                        verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft.
                        Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar.</p>
                    <p>Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete
                        Anhaltspunkte
                        einer
                        Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige
                        Links
                        umgehend entfernen.</p>
                </div>
            </transition>
        </div>
        <div class="impressum" id="imp-col-4">
            <transition name="slide-left">
                <div class="transition-wrapper" v-if="showImpressum === true">
                    <h3>Haftung für Inhalte</h3>
                    <p>Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den
                        allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch
                        nicht
                        verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach
                        Umständen
                        zu
                        forschen, die auf eine rechtswidrige Tätigkeit hinweisen.</p>
                    <p>Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen
                        Gesetzen
                        bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der
                        Kenntnis
                        einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden von entsprechenden
                        Rechtsverletzungen
                        werden
                        wir diese Inhalte umgehend entfernen.</p>
                    <p>Quelle: <a href="https://www.e-recht24.de/" target="_blank">eRecht24</a></p>
                </div>
            </transition>
        </div>
        <div class="content">
            <transition name="slide-left">
                <div class="transition-wrapper" v-if="showImpressum === false">
                    <h2 class="section-head">{{ sectionHeadlineContact }}</h2>
                    <h2 class="section-subhead" v-html="sectionIntroContact"></h2>
                </div>
            </transition>
        </div>
        <transition name="slide-left" mode="out-in">
            <div class="wrapper-go-to" key="1" v-if="showImpressum === false">
                <div class="btn">
                    <a @click="showImpressum = true">Impressum</a>
                    <div></div>
                </div>
            </div>
            <div class="wrapper-go-back" key="2" v-if="showImpressum === true">
                <div class="btn-back">
                    <div></div>
                    <a @click="showImpressum = false">back</a>
                </div>
            </div>
        </transition>
    </section>

</template>

<script>
    export default {
        name: "Contact",
        props: {
            sectionHeadlineContact: String,
            sectionIntroContact: String
        },
        data() {
            return {
                showImpressum: false
            }
        }
    }

</script>

<style lang="css" scoped>

    #contact {
        margin-bottom: 0;
    }

    #contact .wrapper-go-to {
        grid-column: 1 / 2;
        grid-row: 6 / 7;
        align-self: end;
        padding: 1.4rem;
        width: 100%;
    }

    #contact .wrapper-go-back {
        grid-column: 1 / 2;
        grid-row: 6 / 7;
        align-self: end;
        padding: 1.4rem;
        width: 100%;
    }

    .impressum {
        grid-row: 3 / 6;
        overflow: hidden;
    }

    .impressum p {
        font-size: 0.7rem;
        line-height: 1rem;
        padding-right: 1rem;
        padding-bottom: 1rem;
    }

    .impressum h3 {
        font-size: 0.7rem;
        line-height: 1rem;
        font-weight: 600;
        padding-bottom: 1rem;
    }

    #imp-col-1 {
        grid-column: 2 / 3;
    }

    #imp-col-2 {
        grid-column: 3 / 4;
    }

    #imp-col-3 {
        grid-column: 4 / 5;
    }

    #imp-col-4 {
        grid-column: 5 / 6;
    }

    #contact .btn a {
        cursor: pointer;
    }

    #contact .btn-back a {
        cursor: pointer;
    }

    /*** SCREENS ***/

    /* Mobile: Portrait and Landscape */
    @media only screen
    and (min-device-width: 320px)
    and (max-device-width: 600px)
    and (-webkit-min-device-pixel-ratio: 2) {

        #contact .wrapper-go-to {
            align-self: end;
            padding-left: 0;
            width: 100%;
        }
    }

</style>
